import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {Navigate, Route, Routes} from 'react-router-dom';

import {ErrorBoundary} from '@sentry/react';
import {ErrorPage} from 'src/modules/error-page/error-page.components';

import {MCP_TABS} from './constants';
import {clearMcpData} from './services/mcp-slice';
import {AlertsController} from './views/alerts/alerts-controller';
import {PricingController} from './views/pricing/pricing-controller';
import {SetupController} from './views/setup/setup-controller';
import {TabsStructure} from './views/tabs-structure';

type Props = {
    accountId: number,
};

export const McpTab = ({accountId}: Props) => {
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(clearMcpData());
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <ErrorBoundary fallback={<ErrorPage title="MCP Page is unavailable" subtitle="Please try again later."/>}>
            <Routes>
                <Route
                    path={`/${MCP_TABS.SETUP.name}`}
                    element={(
                        <TabsStructure accountId={accountId} activeTab={MCP_TABS.SETUP.name}>
                            <SetupController accountId={accountId}/>
                        </TabsStructure>
                    )}
                />

                <Route
                    path={`/${MCP_TABS.PRICING.name}`}
                    element={(
                        <TabsStructure accountId={accountId} activeTab={MCP_TABS.PRICING.name}>
                            <PricingController accountId={accountId}/>
                        </TabsStructure>
                    )}
                />

                <Route
                    path={`/${MCP_TABS.ALERTS.name}`}
                    element={(
                        <TabsStructure accountId={accountId} activeTab={MCP_TABS.ALERTS.name}>
                            <AlertsController accountId={accountId}/>
                        </TabsStructure>
                    )}
                />

                <Route
                    path="*"
                    element={
                        <Navigate to={`/profile/account/${accountId}/mcp/${MCP_TABS.SETUP.name}`} replace={true}/>
                    }
                />
            </Routes>
        </ErrorBoundary>
    );
};
